"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.starClasses = exports.Stars = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const starClasses = exports.starClasses = (0, _mui.generateUtilityClasses)('Star', ['star', 'empty', 'filled', 'reviewDescription']);
const generateNthOfTypeSelectors = (count, callback) => Array.from({
  length: count
}, (_, i) => callback(i + 1)).join(',');
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  score,
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  margin: 'auto',
  textAlign: 'center',
  // Show filled star for all items up to score
  [`& > div > .${starClasses.star}:nth-of-type(-n + ${score}) .${starClasses.filled}`]: {
    display: 'block'
  },
  [`& > div > .${starClasses.star}:nth-of-type(-n + ${score}) .${starClasses.empty}`]: {
    display: 'none'
  },
  // Show empty star for all items after score
  [`& > div > .${starClasses.star}:nth-of-type(n + ${score + 1}) .${starClasses.filled}`]: {
    display: 'none'
  },
  [`& > div > .${starClasses.star}:nth-of-type(n + ${score + 1}) .${starClasses.empty}`]: {
    display: 'block'
  },
  // Display correct review description based on score
  [`& > .${starClasses.reviewDescription}:nth-of-type(${score + 1})`]: {
    display: 'block'
  },
  [`& > .${starClasses.reviewDescription}:not(:nth-of-type(${score + 1}))`]: {
    display: 'none'
  },
  // Show filled star for hovered item and for all items to the left of hovered item, except when hovering over description
  [`&:has(> div:hover):not(:has(> .${starClasses.reviewDescription}:hover)) > div > .${starClasses.star}`]: {
    [`.${starClasses.filled}`]: {
      display: 'block'
    },
    [`.${starClasses.empty}`]: {
      display: 'none'
    }
  },
  // Show empty star for all items to the right of hovered item, except when hovering over description
  [`&:has(> div:hover):not(:has(> .${starClasses.reviewDescription}:hover)) > div > .${starClasses.star}:hover ~ .${starClasses.star}`]: {
    [`.${starClasses.filled}`]: {
      display: 'none'
    },
    [`.${starClasses.empty}`]: {
      display: 'block'
    }
  },
  // Show hovered star's corresponding description
  [`&:has(> div > .${starClasses.star}:hover) > .${starClasses.reviewDescription}`]: {
    display: 'none'
  },
  [generateNthOfTypeSelectors(5, i =>
  // Hovering star i (1..5) should show the (i+1)-th description (because index 1 maps to score 0 at pos 1)
  `&:has(> div > .${starClasses.star}:nth-of-type(${i}):hover) > .${starClasses.reviewDescription}:nth-of-type(${i + 1})`)]: {
    display: 'block'
  }
}));
const Stars = exports.Stars = (0, _mui.styled)('div')({
  cursor: 'pointer',
  display: 'flex',
  margin: 'auto'
});
